import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Delete } from '../icons';
import { Button } from '../buttons';
import './GlossaryItem.scss';

const GlossaryItem = ({ anchor, title, content }) => {
  const container = useRef(null);
  const [display, setDisplay] = useState(false);
  const [isRight, setIsRight] = useState(false);

  const closeGlossaryCard = () => setDisplay(false);
  const openGlossaryCard = () => setDisplay(true);

  useEffect(() => {
    const handleResize = () => {
      if (container.current) {
        setIsRight(
          container.current.offsetLeft + 20 * 16 > window.innerWidth - 16
        );
      }
    };
    
    handleResize();

    let timeoutId;
    const handleResizeDebounced = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleResize, 100);
    };

    window.addEventListener('resize', handleResizeDebounced);
    return () => {
      window.removeEventListener('resize', handleResizeDebounced);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div
      ref={container}
      className="glossary-item"
      role="button"
      tabIndex="0"
      onFocus={openGlossaryCard}
      onMouseOver={openGlossaryCard}
      onMouseLeave={closeGlossaryCard}
    >
      {anchor}
      <div
        className={classNames('glossary-item-card', {
          '--display': display,
          '--right': isRight
        })}
      >
        <Button
          tabIndex="0"
          onKeyPress={closeGlossaryCard}
          onClick={closeGlossaryCard}
          className="modal__close-button glossary-item-card__close"
          ariaLabel="Close Tooltip"
        >
          <Delete viewBox="8 8 16 16" />
        </Button>
        {title}
        {content}
      </div>
    </div>
  );
};

GlossaryItem.propTypes = {
  anchor: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired
};

export default GlossaryItem;
